import { BusinessPremises }        from '@app/modules/business-premises/models/business-premises.model';
import { Ers }                     from '@app/modules/ers/models/ers.model';
import { ImportTypeEnum }          from '@app/modules/structure-import/models/structure-import.model';
import {
	RequestTssModalModeEnum,
	RequestTssModalTitleEnum
}                                  from '@app/modules/tss/modals/request-tss-modal/request-tss-modal.model';
import { TssLifecycleActionsEnum } from '@app/modules/tss/modals/tss-lifecycle-modal/tss-lifecycle-modal.model';
import {
	TssExternalStatusEnum,
	TssStatus,
	TssStatusEnum,
	TssVariant
}                                  from '@app/modules/tss/models/tss.model';
import { TssState }                from '@app/modules/tss/store/tss.state';
import { ActionTypeWithProps }     from '@core/interfaces/store.interface';
import {
	adapterActions,
	IAdapterActions,
	IBaseProps
}                                  from '@core/store/adapter/adapter.actions';
import {
	createAction,
	props
}                                  from '@ngrx/store';
import {
	IChangeStatusCallback,
	IChangeStatusTssCallbackOptions
}                                  from '@shared/components/status-flow/status-flow.model';


export interface ITssActions extends IAdapterActions<TssVariant> {
	checkAndUpdateEntityState: ActionTypeWithProps<IPropsTssEntity>;
	fccDatacenterRenewApiKey: ActionTypeWithProps<IPropsTssEntity>;
	fccDatacenterTriggerInstallation: ActionTypeWithProps<IPropsTssEntity>;
	requestTssForBusinessPremises: ActionTypeWithProps<IPropsRequestTssForBusinessPremises>;
	requestTssForErs: ActionTypeWithProps<IPropsRequestTssForErs>;
	showTssLifecycle: ActionTypeWithProps<PropsTssLifecycleType>;
	structureImportForTss: ActionTypeWithProps<IPropsStructureImportForTss>;
	updateTssState: ActionTypeWithProps<IPropsUpdateTssState>;
}

export interface IPropsRequestTssForBusinessPremises extends IBaseProps {
	businessPremises?: BusinessPremises;
	forEntity: RequestTssModalModeEnum.BUSINESS_PREMISES;
	titleType: RequestTssModalTitleEnum;
}

export interface IPropsRequestTssForErs extends IBaseProps {
	businessPremises?: BusinessPremises;
	ers?: Ers;
	forEntity: RequestTssModalModeEnum.ERS;
	titleType: RequestTssModalTitleEnum;
}

export interface IPropsStructureImportForTss extends IBaseProps {
	importType: ImportTypeEnum.TSS_EXTERNAL;
}

export interface IPropsTssEntity extends IBaseProps {
	tss: TssVariant;
}

export interface IPropsUpdateTssState extends IBaseProps {
	stateUpdateData?: TssState;
}

export type PropsTssLifecycleType =
	IPropsTssLifecycleActivate
	| IPropsTssLifecycleDelete
	| IPropsTssLifecycleDisable;

export interface IPropsChangeStatusTssEntity extends IBaseProps, IChangeStatusCallback {
	callbackOptions: IChangeStatusTssCallbackOptions;
	targetStatus: TssStatus;
}

export interface IPropsTssLifecycleActivate extends IPropsChangeStatusTssEntity {
	lifecycleAction: TssLifecycleActionsEnum.ACTIVATE;
}

export interface IPropsTssLifecycleDelete extends IPropsChangeStatusTssEntity {
	lifecycleAction: TssLifecycleActionsEnum.DELETE;
	targetStatus: TssExternalStatusEnum.DELETED | TssStatusEnum.DELETED;
}

export interface IPropsTssLifecycleDisable extends IPropsChangeStatusTssEntity {
	lifecycleAction: TssLifecycleActionsEnum.DISABLE;
}

export function tssActions( storeId: string ) {
	return {
		// AdapterActions ##########################################################################################################################
		...adapterActions<TssVariant>( storeId ),

		// ORGANIZATION SPECIFIC ACTIONS ###########################################################################################################
		checkAndUpdateEntityState: createAction( `[${ storeId }] checkAndUpdateEntityState`, props<IPropsTssEntity>() ),
		create: createAction( `[${ storeId }  ENTITY ACTION] Create` ),
		fccDatacenterRenewApiKey: createAction( `[${ storeId }] fccDatacenterRenewApiKey`, props<IPropsTssEntity>() ),
		fccDatacenterTriggerInstallation: createAction( `[${ storeId }] fccDatacenterTriggerInstallation`, props<IPropsTssEntity>() ),
		requestTssForBusinessPremises: createAction( `[${ storeId }] requestTssForBusinessPremises`, props<IPropsRequestTssForBusinessPremises>() ),
		requestTssForErs: createAction( `[${ storeId }] requestTssForErs`, props<IPropsRequestTssForErs>() ),
		showTssLifecycle: createAction( `[${ storeId }] Tss Lifecycle`, props<PropsTssLifecycleType>() ),
		structureImportForTss: createAction( `[${ storeId } ENTITY ACTION] StructureImport`, props<IPropsStructureImportForTss>() ),
		updateTssState: createAction( `[${ storeId } ENTITY ACTION] State Update`, props<IPropsUpdateTssState>() )
	};
}

